import * as React from "react"
import Layout from "./components/layout"
import Seo from "../../ns_components/seo"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import * as classes from "./components/layout.module.css"

// markup
const TrackingPage = ({ location }) => {
    let siteTitle = "Southern California Yacht Racing Group"

    return (
    <Layout location={location} title={siteTitle}>
        <Seo title={siteTitle} />
        <Container fluid>
            <Row>
                <Col>
                    <div className={classes.textSplash}>
                        <h1 className={classes.titles}>Race Tracking</h1>
                    </div>
                </Col>
            </Row>
        </Container>
        <Container className={classes.contentContainer}>
            <Row>
                <Col>
                <h1>Race #4</h1>
                <div>
                <a href="https://yb.tl/qsmdr2022" target="_blank" rel="noreferrer">View on Yellowbrick</a>
                </div>
                <div>
                <iframe title="YB" src="https://yb.tl/qsmdr2022" width="900" height="600" marginwidth="0" marginheight="0" frameborder="no" scrolling="yes" style={{borderStyle: "solid", borderColor: "#CCCCCC", borderWidth: "1px", background: "#FFFFF"}}></iframe>
                </div>
                </Col>
            </Row>
        </Container>
    </Layout>
    )
}

export default TrackingPage